import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticStyle: {
      "padding": "20px 30px"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between",
      "align-items": "center",
      "margin-bottom": "20px"
    }
  }, [_c('h2', [_vm._v("人员群组管理")]), _c('a-space', [_c('a-input-search', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "搜索群组名称"
    },
    on: {
      "pressEnter": _vm.handleSearch
    },
    model: {
      value: _vm.searchGroupName,
      callback: function callback($$v) {
        _vm.searchGroupName = $$v;
      },
      expression: "searchGroupName"
    }
  }), _c('a-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.openAddGroupModal
    }
  }, [_vm._v(" + 新建群组 ")])], 1)], 1), _c('a-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "columns": _vm.columns,
      "data-source": _vm.groupList,
      "pagination": _vm.pagination,
      "loading": _vm.loading
    },
    scopedSlots: _vm._u([{
      key: "status",
      fn: function fn(text, record) {
        return [_c('a-tag', {
          attrs: {
            "color": record && record.status == 1 ? 'green' : 'red'
          }
        }, [_vm._v(" " + _vm._s(record && record.status == 1 ? '启用' : '停用') + " ")])];
      }
    }, {
      key: "action",
      fn: function fn(text, record) {
        return [record ? _c('a-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function click($event) {
              return _vm.handleEdit(record);
            }
          }
        }, [_vm._v(" 编辑 ")]) : _vm._e(), record ? _c('a-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function click($event) {
              return _vm.handleDelete(record);
            }
          }
        }, [_vm._v(" 删除 ")]) : _vm._e()];
      }
    }])
  })], 1), _c('a-modal', {
    attrs: {
      "title": _vm.modalTitle,
      "width": "800px"
    },
    on: {
      "ok": _vm.handleModalOk,
      "cancel": _vm.handleModalCancel
    },
    model: {
      value: _vm.modalVisible,
      callback: function callback($$v) {
        _vm.modalVisible = $$v;
      },
      expression: "modalVisible"
    }
  }, [_c('a-form-model', {
    ref: "groupForm",
    attrs: {
      "model": _vm.groupForm,
      "rules": _vm.groupFormRules
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "群组名称",
      "prop": "groupName",
      "label-col": {
        span: 4
      },
      "wrapper-col": {
        span: 16
      }
    }
  }, [_c('a-input', {
    attrs: {
      "placeholder": "请输入群组名称"
    },
    model: {
      value: _vm.groupForm.groupName,
      callback: function callback($$v) {
        _vm.$set(_vm.groupForm, "groupName", $$v);
      },
      expression: "groupForm.groupName"
    }
  })], 1), _c('a-form-model-item', {
    attrs: {
      "label": "群组描述",
      "prop": "groupDesc",
      "label-col": {
        span: 4
      },
      "wrapper-col": {
        span: 16
      }
    }
  }, [_c('a-textarea', {
    attrs: {
      "placeholder": "请输入群组描述",
      "rows": "3"
    },
    model: {
      value: _vm.groupForm.groupDesc,
      callback: function callback($$v) {
        _vm.$set(_vm.groupForm, "groupDesc", $$v);
      },
      expression: "groupForm.groupDesc"
    }
  })], 1), _c('a-form-model-item', {
    attrs: {
      "label": "状态",
      "prop": "status",
      "label-col": {
        span: 4
      },
      "wrapper-col": {
        span: 16
      }
    }
  }, [_c('a-radio-group', {
    model: {
      value: _vm.groupForm.status,
      callback: function callback($$v) {
        _vm.$set(_vm.groupForm, "status", $$v);
      },
      expression: "groupForm.status"
    }
  }, [_c('a-radio', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("启用")]), _c('a-radio', {
    attrs: {
      "value": 0
    }
  }, [_vm._v("停用")])], 1)], 1), _c('a-form-model-item', {
    attrs: {
      "label": "所属组织",
      "prop": "organId",
      "label-col": {
        span: 4
      },
      "wrapper-col": {
        span: 16
      }
    }
  }, [_c('a-tree-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择所属组织",
      "tree-data": _vm.organTree,
      "max-tag-count": 1,
      "allow-clear": "",
      "show-search": "",
      "dropdown-style": {
        maxHeight: '400px',
        overflow: 'auto'
      }
    },
    on: {
      "change": _vm.handleOrganChange
    },
    model: {
      value: _vm.groupForm.organId,
      callback: function callback($$v) {
        _vm.$set(_vm.groupForm, "organId", $$v);
      },
      expression: "groupForm.organId"
    }
  })], 1), _c('a-form-model-item', {
    attrs: {
      "label": "成员选择",
      "prop": "memberIds",
      "label-col": {
        span: 4
      },
      "wrapper-col": {
        span: 16
      }
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "height": "400px"
    }
  }, [_c('div', {
    staticStyle: {
      "flex": "1",
      "border": "1px solid #d9d9d9",
      "border-radius": "4px",
      "margin-right": "10px",
      "display": "flex",
      "flex-direction": "column"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "10px",
      "border-bottom": "1px solid #d9d9d9"
    }
  }, [_c('a-input-search', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "搜索组织或人员",
      "enter-button": ""
    },
    on: {
      "search": _vm.handleOrganSearch
    },
    model: {
      value: _vm.searchOrganName,
      callback: function callback($$v) {
        _vm.searchOrganName = $$v;
      },
      expression: "searchOrganName"
    }
  })], 1), _c('div', {
    staticStyle: {
      "flex": "1",
      "overflow-y": "auto",
      "padding": "10px"
    }
  }, [_vm.loadingTree ? _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "center",
      "align-items": "center",
      "height": "100%"
    }
  }, [_c('a-spin')], 1) : _c('a-tree', {
    attrs: {
      "tree-data": _vm.organUserTree,
      "expanded-keys": _vm.expandedKeys,
      "replace-fields": {
        key: 'key',
        title: 'title'
      }
    },
    on: {
      "expand": _vm.onExpand
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function fn(item) {
        return [_c('div', {
          staticStyle: {
            "display": "flex",
            "align-items": "center"
          }
        }, [item.dataRef && item.dataRef.isUser ? _c('a-checkbox', {
          staticStyle: {
            "margin-right": "8px"
          },
          attrs: {
            "checked": _vm.selectedMemberIds.includes(item.dataRef.userData.userId)
          },
          on: {
            "change": function change(e) {
              return _vm.handleMemberCheck(e, item.dataRef.userData);
            },
            "click": function click($event) {
              $event.stopPropagation();
            }
          }
        }) : _vm._e(), _c('a-icon', {
          staticStyle: {
            "margin-right": "8px"
          },
          attrs: {
            "type": item.dataRef && item.dataRef.isUser ? 'user' : 'folder'
          }
        }), _c('span', [_vm._v(_vm._s(item.title))])], 1)];
      }
    }])
  })], 1)]), _c('div', {
    staticStyle: {
      "flex": "1",
      "border": "1px solid #d9d9d9",
      "border-radius": "4px",
      "display": "flex",
      "flex-direction": "column"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "10px",
      "border-bottom": "1px solid #d9d9d9",
      "display": "flex",
      "justify-content": "space-between",
      "align-items": "center"
    }
  }, [_c('span', [_vm._v("已选择：" + _vm._s(_vm.selectedMemberIds.length) + "人")]), _vm.selectedMemberIds.length > 0 ? _c('a-popconfirm', {
    attrs: {
      "title": "确认清空已选数据吗?",
      "ok-text": "确认",
      "cancel-text": "取消"
    },
    on: {
      "confirm": _vm.clearSelectedMembers
    }
  }, [_c('a-button', {
    attrs: {
      "type": "link"
    }
  }, [_vm._v("清空")])], 1) : _vm._e()], 1), _c('div', {
    staticStyle: {
      "flex": "1",
      "overflow-y": "auto",
      "padding": "10px"
    }
  }, [_c('a-list', {
    attrs: {
      "data-source": _vm.selectedMembers,
      "size": "small",
      "split": false
    }
  }, _vm._l(_vm.selectedMembers, function (member) {
    return _c('a-list-item', {
      key: member.userId
    }, [_c('div', {
      staticStyle: {
        "display": "flex",
        "align-items": "center",
        "width": "100%"
      }
    }, [_c('a-icon', {
      staticStyle: {
        "margin-right": "8px"
      },
      attrs: {
        "type": "user"
      }
    }), _c('span', {
      staticStyle: {
        "flex": "1"
      }
    }, [_vm._v(_vm._s(member.userName) + " (" + _vm._s(member.postName) + ")")]), _c('a-icon', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "type": "close"
      },
      on: {
        "click": function click($event) {
          return _vm.removeMember(member.userId);
        }
      }
    })], 1)]);
  }), 1)], 1)])])])], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };